<template>
  <v-container>
      <v-row>
        <ContactDetail />
        <ContactForm />
      </v-row>
  </v-container>
</template>

<script>

  import ContactDetail from "@/components/ContactDetail.vue";
  import ContactForm from "@/components/ContactForm.vue";

  export default {
    components: {
      ContactDetail,
      ContactForm
    }
  }
</script>

<style scoped>
* {
  color: #311B92
}
</style>